// Filas admin Everlog da jornada da transportadora: curadoria da entrada na
// Rede (PO1-2299), pedidos do embarcador (PO1-3283) e homologação por
// transportadora (PO1-3107 → PO1-3281).
import api from "./api";

const BASE = "/onboarding-transportadora/admin";

// status: abertos|pendente (curadoria) | pedidos (PO1-3283) | rede (PO1-3647) | recusado | todos.
export async function listarCuradoria(params = {}) {
  const { data } = await api.get(`${BASE}/curadoria`, { params });
  return data;
}

// PO1-3647 (épico PO1-3359): o pedido de entrada na Rede Everlog por trás de um
// convite com Origem PEDIDO_REDE. { pedido, cobertura, anexos (url pré-assinada
// de 15 min), api | null }; 404 quando o convite não é pedido da Rede.
export async function obterPedidoRede(idConvite) {
  const { data } = await api.get(`${BASE}/curadoria/${idConvite}/pedido-rede`);
  return data;
}

// ─── PO1-3649: painel do funil da Rede Everlog ──────────────────────────────
// { periodo, etapas: [{ chave, rotulo, total, parados: [...] }], temposMedios: [{ de, para, dias }] }
export async function obterFunilRede({ de, ate } = {}) {
  const { data } = await api.get(`${BASE}/rede/funil`, { params: { de, ate } });
  return data;
}

// xlsx como blob; vira <a download> na tela (utils/downloadBlob).
export async function baixarFunilRedeXlsx({ de, ate } = {}) {
  const resp = await api.get(`${BASE}/rede/funil.xlsx`, { params: { de, ate }, responseType: "blob" });
  return resp.data;
}

// "Liberar" (R8): o servidor reconfere a regra da 0001; { nome } só para raiz
// nova. 409 matriz_pendente devolve `matriz` com o estado atual da checagem.
// Item sem e-mail (entrada pela porta única) é liberado sem convite: o
// onboarding da transportadora segue sozinho.
export async function aprovarCuradoria(id, payload) {
  const { data } = await api.post(`${BASE}/curadoria/${id}/aprovar`, payload);
  return data;
}

export async function recusarCuradoria(id, { motivo }) {
  const { data } = await api.post(`${BASE}/curadoria/${id}/recusar`, { motivo });
  return data;
}

// PO1-3283: "Iniciar onboarding" de um pedido do embarcador (fase 1).
// body { modoAuth?: 'senha'|'chave', chaves?: [], email? }.
// Resposta { pedido, onboarding: { estado, passos, curadoria? } } (200), ou o
// formato curto { estado, resultado } de uma API mais nova.
export async function iniciarPedidoCuradoria(id, payload = {}) {
  const { data } = await api.post(`${BASE}/curadoria/pedidos/${id}/iniciar`, payload);
  return data;
}

// Fila de homologação: UMA LINHA POR TRANSPORTADORA (matriz) desde a PO1-3281,
// com os embarcadores que esperam em `embarcadores[]`.
export async function listarHomologacao(params = {}) {
  const { data } = await api.get(`${BASE}/homologacao`, { params });
  return data;
}

// ─── PO1-3281: ações por TRANSPORTADORA (agem em todos os vínculos dela) ────
export async function aprovarTransportadoraHomologacao(idTransportadora) {
  const { data } = await api.post(`${BASE}/homologacao/transportadoras/${idTransportadora}/aprovar`);
  return data;
}

export async function devolverTransportadoraHomologacao(idTransportadora, { motivo }) {
  const { data } = await api.post(`${BASE}/homologacao/transportadoras/${idTransportadora}/devolver`, { motivo });
  return data;
}

// PO1-3491: corrigir pela própria fila. Completa só o que está vazio pela Receita.
export async function completarReceitaHomologacao(idTransportadora) {
  const { data } = await api.post(`${BASE}/homologacao/transportadoras/${idTransportadora}/receita`);
  return data;
}

// Reenviar para homologação depois de devolvida. { idEmbarcador } limita a um par.
export async function reenviarTransportadoraHomologacao(idTransportadora, { idEmbarcador } = {}) {
  const { data } = await api.post(`${BASE}/homologacao/transportadoras/${idTransportadora}/reenviar`, {
    idEmbarcador: idEmbarcador || undefined,
  });
  return data;
}

// ─── Compat: rotas por vínculo (:id da habilitação), anteriores à PO1-3281 ──
export async function aprovarHomologacao(id) {
  const { data } = await api.post(`${BASE}/homologacao/${id}/aprovar`);
  return data;
}

export async function devolverHomologacao(id, { motivo }) {
  const { data } = await api.post(`${BASE}/homologacao/${id}/devolver`, { motivo });
  return data;
}
